import { jsx as t } from "react/jsx-runtime";
import "react";
import { classes as r } from "../../../../utils/helpers.js";
import '../../../../assets/TextSlide.css';const e = {
  "text-slide": "_text-slide_1h4rx_1",
  "text-slide__text": "_text-slide__text_1h4rx_9"
};
function c({
  text: s = "",
  backgroundColor: l = "#fff",
  textColor: i = "#444",
  fontSize: x = "2.4rem"
}) {
  return /* @__PURE__ */ t("div", { className: e["text-slide"], children: /* @__PURE__ */ t(
    "div",
    {
      className: r([e["text-slide__text"], "text-slide__text"]),
      style: {
        backgroundColor: l,
        color: i,
        fontSize: x
      },
      children: s
    }
  ) });
}
export {
  c as TextSlide,
  c as default
};
